module.exports = __webpack_public_path__ + "img/bank_icon4.a776ea47.png";